<template>
    <div class="col-lg-12">
        <div class="card border-top-0">

            <div class="tab-content">
                <div class="tab-pane fade show active" id="profileTab" role="tabpanel">
                    <div class="card-body personal-info">
                        <form @submit.prevent="submitForm">
                            <div class="mb-4 d-flex align-items-center justify-content-between">
                                <h5 class="fw-bold mb-0 me-4">
                                    <span class="d-block mb-2">Hayvan Kartı:</span>
                                    <span class="fs-12 fw-normal text-muted text-truncate-1-line">Hayvan kartlarını
                                        buradan düzenleyebilirsiniz.</span>
                                </h5>
                                <div class="d-flex gap-2">
                                    <router-link to="/animal/list/1"
                                        class="btn btn-lg btn-light-brand bg-orange">Liste</router-link>
                                    <router-link :to="`/animal/detail/${animalId}`"
                                        class="btn btn-lg btn-light-brand bg-blue text-white">Detay</router-link>
                                    <button type="submit"
                                        class="btn btn-lg btn-light-brand bg-green text-white">Kaydet</button>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Resim: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="mb-4 mb-md-0 d-flex gap-4 your-brand">
                                        <div
                                            class="wd-100 ht-100 position-relative overflow-hidden border border-gray-2 rounded">
                                            <!-- <img src="assets/images/avatar/1.png"
                                            class="upload-pic img-fluid rounded h-100 w-100" alt=""> -->
                                            <div
                                                class="position-absolute start-50 top-50 end-0 bottom-0 translate-middle h-100 w-100 hstack align-items-center justify-content-center c-pointer upload-button">
                                                <i class="feather feather-camera" aria-hidden="true"></i>
                                            </div>
                                            <input class="file-upload" type="file" accept="image/*">
                                        </div>
                                        <div class="d-flex flex-column gap-1">
                                            <div class="fs-11 text-gray-500 mt-2"># Upload your prifile</div>
                                            <div class="fs-11 text-gray-500"># Avatar size 150x150</div>
                                            <div class="fs-11 text-gray-500"># Max upload size 2mb</div>
                                            <div class="fs-11 text-gray-500"># Allowed file types: png, jpg, jpeg</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="animal-id-number" class="fw-semibold">Kimlik No: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="animal-id-number"
                                            v-model="animal.id_number" placeholder="Kimlik No">
                                    </div>
                                </div>

                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="animal-species" class="fw-semibold">Türü: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <select v-model="animal.species" @change="fetchBreed(this.species.id)"
                                            class="form-control" id="animal-species"
                                            data-select2-selector="animal-species">
                                            <option value="" disabled>Tür Seç</option>
                                            <option v-for="specie in species" :key="specie.id" :value="specie.id">
                                                {{ specie.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label for="animal-breed" class="fw-semibold">Cinsi: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <select v-model="animal.breed" :disabled="!animal.species" class="form-control"
                                            id="animal-breed" data-select2-selector="animal-breed">
                                            <option value="">Irk Seç</option>
                                            <option v-for="item in breed" :key="item.id" :value="item.id">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="animal-age" class="fw-semibold">Yaşı: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="animal-age" v-model="animal.age"
                                            placeholder="Yaşı">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label for="animal-gender" class="fw-semibold">Cinsiyeti: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <select class="form-control" id="animal-gender" v-model="animal.gender"
                                            data-select2-selector="animal-gender">
                                            <option disabled value="">Cinsiyeti</option>
                                            <option value="Erkek">Erkek
                                            </option>
                                            <option value="Dişi">Dişi
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="arrival-date" class="fw-semibold">Geliş Tarihi: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="arrival-date"
                                            v-model="animal.arrival_date">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label for="surrender-date" class="fw-semibold">Çıkış Tarihi: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="surrender-date"
                                            v-model="animal.surrender_date" placeholder="Çıkış Tarihi">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="owner-address" class="fw-semibold">Geldiği Adres: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="owner-address"
                                            v-model="animal.owner_address" placeholder="Geldiği Adres">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="behaviour-pattern" class="fw-semibold">Davranış Şekli: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="behaviour-pattern"
                                            v-model="animal.behavior_pattern" placeholder="Davranış Şekli">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center border border-solid border-gray-2 rounded pb-4">
                                <h5>Sahibinin</h5>
                                <div class="col-lg-1">
                                    <label for="owner-name" class="fw-semibold">Adı Soyadı: </label>
                                </div>
                                <div class="col-lg-3">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="owner-name" v-model="animal.owner"
                                            placeholder="Adı Soyadı">
                                    </div>
                                </div>
                                <div class="col-lg-1">
                                    <label for="owner-phone" class="fw-semibold">Telefonu: </label>
                                </div>
                                <div class="col-lg-3">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="owner-phone"
                                            v-model="animal.owner_phone" placeholder="Telefonu">
                                    </div>
                                </div>
                                <div class="col-lg-1">
                                    <label for="owner-email" class="fw-semibold">E-Posta: </label>
                                </div>
                                <div class="col-lg-3">
                                    <div class="input-group">
                                        <input type="email" class="form-control" id="owner-email"
                                            v-model="animal.owner_email" placeholder="E-Posta">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="description" class="fw-semibold">Diğer Husular: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="description"
                                            v-model="animal.description" placeholder="Diğer Husular">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import tz from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(customParseFormat);
dayjs.extend(tz);
dayjs.extend(utc);
import { formatDate } from '../../services/helper';
export default {
    name: 'EditAnimal',
    data() {
        return {
            animal: {
                arrival_date: ''
            },
            species: [],
            breed: [],
            shelters: [],
            animalId: this.$route.params.id,
        }
    },
    async mounted() {
        const animalId = this.$route.params.id
        console.log('animal id', animalId);
        this.fetchAnimal(animalId);
        this.fetchShelters();
        this.fetchSpecies();
    },
    methods: {
        async fetchSpecies() {
            try {
                const response = await this.$axios.get('animal_species/?pagination=false');
                this.species = response.data;
                console.log('species: ', this.species);
            } catch (error) {
                console.log(error);
            }
        },
        async fetchBreed() {
            console.log('fetchBreed', this.animal.species);
            if (this.animal.species) {
                try {
                    const response = await this.$axios.get(`animal_breed/?species=${this.animal.species}&pagination=false`);
                    this.breed = response.data;
                } catch (error) {
                    console.log(error);
                }
            }
        },
        async fetchShelters(name) {
            try {
                const response = await this.$axios.get(`animal_shelter/`);
                this.shelters = response.data.results;
                console.log(this.shelters);
            } catch (error) {
                Swal.fire('Hata', error, 'error');
                console.log(error);
            }
        },
        async fetchAnimal(id) {
            try {
                const response = await this.$axios.get(`animal/${id}/`);
                this.animal = response.data;
                this.animal.arrival_date = this.animal.arrival_date ? dayjs(this.animal.arrival_date).format('DD.MM.YYYY') : '';
                this.animal.surrender_date = this.animal.surrender_date ? dayjs(this.animal.surrender_date).format('DD.MM.YYYY') : null;
                this.fetchBreed();
                console.log('animal');
                console.log(this.animal);
            } catch (error) {
                Swal.fire('Hata', error, 'error');
                console.log(error);
            }
        },
        async submitForm() {
            try {
                const payload = {
                    ...this.animal,
                    arrival_date: dayjs(this.animal.arrival_date, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    surrender_date: this.animal.surrender_date ? dayjs(this.animal.surrender_date, 'DD.MM.YYYY').format('YYYY-MM-DD') : null,
                };
                const response = await this.$axios.put(`animal/${this.animal.id}/`, payload);
                Swal.fire('Başarılı', 'Hayvan başarıyla güncellendi.', 'success');
                console.log(response);
                this.$router.push({ name: 'AnimalDetail', params: { id: this.animal.id } });

            } catch (error) {
                Swal.fire('Hata', error, 'error');
                console.log(error);
            }
        }
    }
}
</script>